"use strict";

exports.__esModule = true;
exports.default = void 0;

var secondsToMs = function secondsToMs(seconds) {
  return seconds * 1000;
};

var minutesToMs = function minutesToMs(minutes) {
  return secondsToMs(60 * minutes);
};

var hoursToMs = function hoursToMs(hours) {
  return minutesToMs(60 * hours);
};

var daysToMs = function daysToMs(days) {
  return hoursToMs(24 * days);
};

var durationToMilliseconds = function durationToMilliseconds(_ref) {
  var _ref$days = _ref.days,
      days = _ref$days === void 0 ? 0 : _ref$days,
      _ref$hours = _ref.hours,
      hours = _ref$hours === void 0 ? 0 : _ref$hours,
      _ref$minutes = _ref.minutes,
      minutes = _ref$minutes === void 0 ? 0 : _ref$minutes,
      _ref$seconds = _ref.seconds,
      seconds = _ref$seconds === void 0 ? 0 : _ref$seconds;
  return daysToMs(days) + hoursToMs(hours) + minutesToMs(minutes) + secondsToMs(seconds);
};

var _default = durationToMilliseconds;
exports.default = _default;